import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'

import { useAuthStore } from '../stores/authStore.js'
import { useScopeStore } from '../stores/scopeStore.js'

import { resolveActiveViewMode } from '../config/auth.config.js'

import themeUtility from '../utils/theme.utility.js'

export function useTheme() {
  const authStore = useAuthStore()
  const scopeStore = useScopeStore()
  const route = useRoute()
  const { scope } = storeToRefs(scopeStore)

  const viewMode = computed(() => resolveActiveViewMode(route, authStore.user, scope.value.kind))

  const logoUrl = computed(() => themeUtility.logo(authStore.user, viewMode.value))
  const footer = computed(() => themeUtility.footer(authStore.user, viewMode.value))

  /**
   * Apply styling for the user currently in the session store. For boot, once
   * the store is populated.
   *
   * @returns {void}
   */
  function initStyles() {
    themeUtility.styles(authStore.user, viewMode.value)
  }

  /**
   * Apply styling for an explicit user / shell, e.g. after session or
   * view-mode changes.
   *
   * @param {object|null|undefined} [user]
   * @param {string|null|undefined} [mode]
   * @returns {void}
   */
  function loadStyles(user = authStore.user, mode = viewMode.value) {
    themeUtility.styles(user, mode)
  }

  return {
    viewMode,
    logoUrl,
    footer,
    initStyles,
    loadStyles,
  }
}
